import { render, staticRenderFns } from "./ReceiptDonutChart.vue?vue&type=template&id=3162246a&scoped=true"
import script from "./ReceiptDonutChart.vue?vue&type=script&lang=js"
export * from "./ReceiptDonutChart.vue?vue&type=script&lang=js"
import style0 from "./ReceiptDonutChart.vue?vue&type=style&index=0&id=3162246a&prod&scoped=true&lang=css"
import style1 from "./ReceiptDonutChart.vue?vue&type=style&index=1&id=3162246a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3162246a",
  null
  
)

export default component.exports